import React from 'react';

const DocFinderIcon: React.FC<{ className?: string }> = ({ className }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 149.04 144.08"
            className={className}
        >
            <path
                d="M57.82,104.32c-27.25,0-49.41-22.17-49.41-49.41S30.57,5.5,57.82,5.5s49.41,22.17,49.41,49.41-22.17,49.41-49.41,49.41Z"
                fill="#fff"
            />
            <path
                d="M57.82,11c24.21,0,43.91,19.7,43.91,43.91s-19.7,43.91-43.91,43.91S13.91,79.12,13.91,54.91,33.6,11,57.82,11M57.82,0C27.49,0,2.91,24.58,2.91,54.91s24.58,54.91,54.91,54.91,54.91-24.58,54.91-54.91S88.14,0,57.82,0h0Z"
                fill="currentColor"
            />
            <line
                x1="93.34"
                y1="93.16"
                x2="143.54"
                y2="138.58"
                fill="none"
                stroke="currentColor"
                strokeWidth="11"
                strokeLinecap="round"
                strokeMiterlimit="10"
            />
            <path
                d="M36.27,42.92c11.02.16,40.33-.24,46.08,0"
                fill="none"
                stroke="currentColor"
                strokeWidth="11"
                strokeLinecap="round"
                strokeMiterlimit="10"
            />
            <path
                d="M36.27,68.92c10.49.09,26.79-.19,32.48-.04"
                fill="none"
                stroke="currentColor"
                strokeWidth="11"
                strokeLinecap="round"
                strokeMiterlimit="10"
            />
        </svg>
    );
};

export default DocFinderIcon;
